import { useMutation } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";
import { IUpsertActivityRequest } from "../types/CrmActivityTypes";

export const useCreateActivityMutation = () => {
  const crmApi = makeCRMApi();
  
  const createActivityMutation = useMutation({
    mutationKey: ['crm-create-activity'],
    mutationFn: (requestData: IUpsertActivityRequest) => crmApi.createActivity(requestData),
  });
  
  return createActivityMutation;
}
